import * as React from "react";
import { MultiStepFooter, TooltipStep } from "@skbkontur/react-ui-tour";
import type { PopupPositionsType } from "@skbkontur/react-ui";
import { useEffect, useState } from "react";

import { useMetrics } from "../../Internals/Metrics/MetricsProviderContext";
import { MINITOUR_SHOW } from "../../metricsAction";

export interface MinitourProps {
    id: string;
    label: string;
    children: React.ReactNode | readonly React.ReactNode[];
    width?: number | undefined;
    positions: PopupPositionsType[];
    isOpen?: boolean;
    setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
    onClose?: () => void;
    openFromLink?: boolean;
    minitourEnabled?: boolean;
    openedFrom?: string;
    stepIndex: number;
    stepsCount: number;
    onNext: () => void;
    onPrev: () => void;
    customFooterButtonText?: string;
}

export function TooltipStep2({
    label,
    children: minitourChildren,
    width,
    positions,
    isOpen,
    setIsOpen,
    onClose,
    openedFrom,
    stepIndex,
    stepsCount,
    onNext,
    onPrev,
    customFooterButtonText,
}: MinitourProps): JSX.Element {
    const ref = React.useRef<HTMLDivElement>(null);
    const isOpenMinitour = !!((ref.current as Element) && isOpen && setIsOpen && onClose);
    const [metricSended, setMetricSended] = useState(false);
    const track = useMetrics();

    const onNextClick = function () {
        onNext();
        // Минитур может выдавать ошибки в консоль, поэтому добавлен пустой метод
        // Можно убрать когда решится issue: https://git.skbkontur.ru/ke/keweb.front.components/-/issues/1
    };
    const onPrevClick = function () {
        onPrev();
        // Минитур может выдавать ошибки в консоль, поэтому добавлен пустой метод
        // Можно убрать когда решится issue: https://git.skbkontur.ru/ke/keweb.front.components/-/issues/1
    };
    useEffect(() => {
        if (isOpenMinitour && !metricSended) {
            setMetricSended(true);
            track(MINITOUR_SHOW, {
                from: openedFrom,
            });
        }
    }, [isOpenMinitour]);

    const handleClickTargetAction = () => {
        if (isOpenMinitour) {
            setIsOpen(false);
            onClose();
        }
    };

    const customFooter = () => (
        <MultiStepFooter
            stepsCount={stepsCount}
            activeStepIndex={stepIndex + 1}
            onPrev={onPrevClick}
            onNext={onTourClose}
            nextButtonText={customFooterButtonText}
        />
    );

    const onTourClose = () => {
        if (isOpenMinitour) {
            setIsOpen(false);
            onClose();
        }
    };

    return (
        <>
            <span ref={ref} style={{ display: "inline-block" }}>
                <span onClick={handleClickTargetAction}>{minitourChildren}</span>
                {isOpenMinitour && (
                    <span>
                        {stepIndex === stepsCount - 1 && customFooterButtonText ? (
                            <TooltipStep
                                width={width}
                                content={label}
                                anchorElement={() => ref.current as HTMLElement}
                                allowedPositions={positions}
                                stepIndex={stepIndex}
                                stepsCount={stepsCount}
                                onNext={onNextClick}
                                onPrev={onPrevClick}
                                footer={customFooter}
                                onClose={onTourClose}
                            />
                        ) : (
                            <TooltipStep
                                width={width}
                                content={label}
                                anchorElement={() => ref.current as HTMLElement}
                                allowedPositions={positions}
                                stepIndex={stepIndex}
                                stepsCount={stepsCount}
                                onNext={onNextClick}
                                onPrev={onPrevClick}
                                onClose={onTourClose}
                            />
                        )}
                    </span>
                )}
            </span>
        </>
    );
}
